function CloseSignature() {
	window.close()

	return null
}

export default CloseSignature
